import styled from '@emotion/styled';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Typography } from '@material-ui/core';
import Container from '../../atoms/Container';
import breakpoints from '../../theme/material/breakpoints';
import Panel from '../../atoms/panels/Panel';
import colors from '../../theme/colors';
import { spacing, getStatusColor, getTextColor } from '../../style';
import { FONT_FAMILIES } from '../../theme/material/constants';
import Button from '../../atoms/buttons/Button';

export const StyledJoinContainer = styled('div')({
  [breakpoints.down('sm')]: {
    marginBottom: 22,
  },
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledPanel = styled(Panel)({
  backgroundColor: '#FFF',
  height: '100%',
  border: '1px solid rgb(218, 225, 233)',
  marginBottom: '0 !important;',
  position: 'relative !important',
  padding: '30px 92px',
  placeContent: 'center',

  [breakpoints.down('md')]: {
    padding: '30px',
  },

  [breakpoints.down('sm')]: {
    backgroundColor: '#FFF',
  },

  [breakpoints.down('xs')]: {
    padding: '20px 15px',
  },
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledScrollbar = styled(Scrollbars)({
  height: '100%',
  position: 'relative',
  borderRadius: '5px',
  [breakpoints.down('sm')]: {
    height: '100% !important',
  },
  '> div:first-of-type': {
    position: 'relative !important',
    maxHeight: '650px',

    [breakpoints.down('sm')]: {
      position: 'relative',
      height: '100%',
      maxHeight: '100%',
    },
  },
});

export const StyledContainer = styled(Container)({
  marginBottom: 100,
  maxWidth: 500,
  [breakpoints.down('sm')]: {
    marginBottom: 'auto',
  },
});

export const BottomMsg = styled('p')({
  textAlign: 'center',
  margin: '0px 0px',
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '-0.5px',
  color: colors.gray['1000'],
  [breakpoints.down('sm')]: {
    marginBottom: 0,
  },
});

export const ErrorDiv = styled('div')({
  margin: -22,
  marginBottom: 12,
  backgroundColor: 'rgb(204, 84, 84)',
  padding: 12,
  borderRadius: '4px 4px 0 0',
  color: '#fff',
});

export const ThirdPartyOptions = styled('div')({
  textAlign: 'center',
});

export const HeadlineContainer = styled('div')(() => ({
  textAlign: 'center',
  ...getTextColor().BRAND,
}));

export const Headline = styled('h1')(() => ({
  margin: 0,
  display: 'inline-block',
  color: colors.light.blue.primary,
  fontSize: 22,
  fontWeight: 700,
  letterSpacing: '-0.3px',
  lineHeight: '27px',
}));

export const StepText = styled(Typography)({
  display: 'inline-block',
  fontSize: 16,
  fontWeight: 400,
  color: colors.light.gray.light,
  letterSpacing: '-0.3px',
});

export const CheckBoxDiv = styled('div')({
  textAlign: 'center',
  margin: '0 auto',
  maxWidth: 280,
  ...spacing.MARGIN_BOTTOM_LG,
});

export const BirthdayContainer = styled('div')({
  marginBottom: 0,
  position: 'relative',
});
export const BirthdayWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
});

export const StatusMessage = styled('div')<{ status: string }>(
  {
    marginTop: 5,
    fontSize: 15,
  },
  ({ status }) => ({
    color: status !== 'default' ? getStatusColor()[status] : 'inherit',
  })
);

export const ButtonWrapper = styled('div')({
  display: 'inline-flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
  marginTop: 20,
  marginBottom: 20,
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const ContinueButton = styled(Button)(() => ({
  background: colors.gray['100'],
  border: `1px solid ${colors.gray['1200']}`,
  borderRadius: '4px',
  fontSize: '14px !important',
  fontWeight: 400,
  fontFamily: FONT_FAMILIES.primary,
  letterSpacing: '-0.28px',
  width: '100%',
  height: 40,
  color: colors.light.gray.light,
}));

export const emailCustomStyle = {
  fontSize: 15,
  marginTop: 20,
  fontWeight: 700,
};

export const editEmailStyle = {
  fontSize: 15,
  color: '#2B8FD7',
  fontWeight: 700,
  textDecoration: 'underline',
};

export const signInLinkStyle = {
  color: '#2B8FD7',
  fontWeight: 700,
  textDecoration: 'underline',
  textUnderlinePosition: 'under',
};

export const InfoErrorStyle = styled('div')({
  background: 'rgba(234, 244, 251, 0.50)',
  borderRadius: 8,
  display: 'flex',
  padding: '20px 16px',
  flexDirection: 'column',
  alignDtems: 'center',
  gap: 15,
  alignSelf: 'stretch',
});
